import { render, staticRenderFns } from "./DonationHeader.vue?vue&type=template&id=5da7f9a4&"
import script from "./DonationHeader.vue?vue&type=script&lang=js&"
export * from "./DonationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports